import { StContentArea } from './ContentArea.styled'

import type { ReactNode } from 'react'

type ContentAreaProps = {
  children: ReactNode
  gridArea: 'content' | 'content-detail'
  zIndex?: number
  scrollable?: boolean
  flexInner?: boolean // render the children inside a flex container
  divider?: boolean
}

const ContentArea = ({ children, gridArea, zIndex, scrollable, flexInner, divider = false }: ContentAreaProps) => {
  return children ? (
    <StContentArea zIndex={zIndex} gridArea={gridArea} scrollable={scrollable} flexInner={flexInner} divider={divider}>
      {children}
    </StContentArea>
  ) : null
}

export { ContentArea }
